import { cn } from "../../lib/utils";

export type Tab = {
  label: string;
  // TODO: Implement this
  count?: number;
  value: string;
  icon: React.ReactNode;
};

interface TabBarProps {
  tabs: Tab[];
  activeTab: Tab;
  setActiveTab: (tab: Tab) => void;
}

export default function TabBar({ tabs, activeTab, setActiveTab }: TabBarProps) {
  const tabElement = (tab: Tab, icon: React.ReactNode) => {
    return (
      <div
        key={tab.value}
        className={cn(
          "flex items-center gap-2 cursor-pointer border border-transparent p-2 rounded-md select-none",
          activeTab === tab
            ? "text-accent border-border"
            : "text-secondary hover:text-accent"
        )}
        onClick={() => setActiveTab(tab)}
      >
        <div className="w-4 h-4">{icon}</div>
        <div className="text-sm font-medium">{tab.label}</div>
      </div>
    );
  };

  const tabContainer = () => {
    return (
      <div className="flex rounded-md text-sm border border-input w-fit">
        {tabs.map((tab) => {
          return tabElement(tab, tab.icon);
        })}
      </div>
    );
  };

  return <div>{tabContainer()}</div>;
}
